/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface ArchivePageState {
  isShareArchivePageModalOpen: boolean;
}

const initialState: ArchivePageState = {
  isShareArchivePageModalOpen: false,
};

export const archivePageSlice = createSlice({
  name: 'ArchivePageState',
  initialState,
  reducers: {
    setIsShareArchivePageModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isShareArchivePageModalOpen = action.payload;
    },
  },
});

export const { setIsShareArchivePageModalOpen } = archivePageSlice.actions;

export default archivePageSlice.reducer;
